import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslationService } from '@app/shared/services/translation.service';
import { L10N_LOCALE, L10nTranslatePipe } from 'angular-l10n';
import { Router } from '@angular/router';
import {
  LocalStorageAsyncService,
  LocalStorageKeys,
} from '@app/shared/services/local-storage-async.service';

@Component({
  selector: 'gingr-over-18',
  templateUrl: './over18.component.html',
  styleUrls: ['./over18.component.scss'],
  standalone: true,
  imports: [SvgIconComponent, L10nTranslatePipe],
})
export class Over18Component implements OnInit, AfterViewInit {
  @ViewChild('age_modal', { static: false })
  ageModal: ElementRef<HTMLDialogElement>;

  readonly translationService = inject(TranslationService);
  readonly locale = inject(L10N_LOCALE);
  readonly router = inject(Router);
  readonly localStorageAsyncService = inject(LocalStorageAsyncService);

  ngOnInit() {
    if (
      LocalStorageAsyncService.getStorageValueWithTimestamp(
        LocalStorageKeys.over18ApprovalKey,
        10
      ) === 'true'
    ) {
      this.router.navigate(['/gingrs']);
    }
  }

  ngAfterViewInit() {
    if (this.ageModal?.nativeElement?.showModal) {
      this.ageModal.nativeElement.showModal();
      this.ageModal.nativeElement.addEventListener('cancel', (event) => {
        event.preventDefault();
      });
    }
  }

  over18() {
    this.localStorageAsyncService.setStorageValueAsyncWithTimestamp(
      LocalStorageKeys.over18ApprovalKey,
      'true'
    );
    const redirectUrl = LocalStorageAsyncService.getStorageValue(
      LocalStorageKeys.redirectUrlAfterOver18
    );
    LocalStorageAsyncService.removeStorageValue(
      LocalStorageKeys.redirectUrlAfterOver18
    );
    this.router.navigate(redirectUrl ? [redirectUrl] : ['/gingrs']);
  }

  under18() {
    window.location.href = 'https://google.com';
  }

  closeModal(redirectUrl?: string) {
    this.ageModal.nativeElement.close();
    this.router.navigate(redirectUrl ? [redirectUrl] : ['/gingrs']);
  }
}
